import styled from 'styled-components';

const base = styled.nav`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  /* min-height: 0 garante que o filho com overflow (Wrapper.Buttons)
     possa encolher e rolar internamente em vez de empurrar o botao de
     logout pra fora da viewport em telas baixas (HD 1366x768). */
  min-height: 0;
  width: 11rem;
  padding: 0.5rem;
  box-sizing: border-box;
  background-color: ${(props) => props.theme.colors.mainColor};
`;

const Frame = {
  Base: base,
};

export default Frame;
